import React, { Component } from 'react';
import Table from '../../../../../../components/_table/Table';
import { comparePrePropsAndNextProps } from '../../../../../../lib/common';
import { columns } from './columns';
import './ProductExcelBulkEditList.scss';

class ProductExcelBulkEditList extends Component {
  /**
   *  Component 의 변경되는 props 와 state 가 있을 경우에만,
   *  render 메소드를 호출할 수 있도록 함
   */
  shouldComponentUpdate = (nextProps, nextState) => {
    return comparePrePropsAndNextProps([
      [nextProps, this.props],
      [nextState, this.state],
    ]);
  };

  render() {
    const { bulkEditProductValidResultList } = this.props;

    return (
      <Table
        className="product-excel-bulk-edit-list"
        columns={() => columns()}
        rowKey={(record) => record.key}
        list={bulkEditProductValidResultList}
        scroll={{ x: true }}
        bordered={true}
        showPagination={false}
      />
    );
  }
}

export default ProductExcelBulkEditList;
